/**
 * Fetches price feed data from Pyth and adds update instructions to the transaction
 *
 * @param tx - The transaction to add price updates to
 * @param priceIDs - Array of Pyth price feed IDs
 * @param pythClient - SuiPythClient instance
 * @param pythConnection - SuiPriceServiceConnection instance
 * @returns Promise resolving to an array of price info object IDs
 */
export async function getPriceInfoObjectIdsWithUpdate(tx, priceIDs, pythClient, pythConnection) {
    const priceFeedUpdateData = await pythConnection.getPriceFeedsUpdateData(priceIDs);
    const priceInfoObjectIds = await pythClient.updatePriceFeeds(tx, priceFeedUpdateData, priceIDs);
    return priceInfoObjectIds;
}
/**
 * Retrieves price info object IDs from Pyth without updating them
 *
 * @param priceIDs - Array of Pyth price feed IDs
 * @param pythClient - SuiPythClient instance
 * @returns Promise resolving to an array of price info object IDs or undefined
 */
export async function getPriceInfoObjectIdsWithoutUpdate(priceIDs, pythClient) {
    const priceInfoObjectIds = await Promise.all(priceIDs.map((priceId) => {
        return pythClient.getPriceFeedObjectId(priceId);
    }));
    return priceInfoObjectIds;
}
/**
 * Adds oracle price update instructions to a transaction
 *
 * @param tx - The transaction to add price updates to
 * @param args - Update price transaction arguments
 * @param constants - Protocol constants
 */
export function updatePriceTransaction(tx, args, constants) {
    tx.moveCall({
        target: `${constants.ALPHAFI_LATEST_ORACLE_PACKAGE_ID}::oracle::update_price_from_pyth`,
        arguments: [
            tx.object(constants.ALPHAFI_ORACLE_OBJECT_ID),
            tx.object(args.priceInfoObject),
            tx.object(constants.SUI_CLOCK_OBJECT_ID),
        ],
    });
    const coinTypeName = tx.moveCall({
        target: `0x1::type_name::get`,
        typeArguments: [args.coinType],
    });
    const oraclePriceInfo = tx.moveCall({
        target: `${constants.ALPHAFI_LATEST_ORACLE_PACKAGE_ID}::oracle::get_price_info`,
        arguments: [tx.object(constants.ALPHAFI_ORACLE_OBJECT_ID), coinTypeName],
    });
    tx.moveCall({
        target: `${constants.ALPHALEND_LATEST_PACKAGE_ID}::alpha_lending::update_price`,
        arguments: [tx.object(constants.LENDING_PROTOCOL_ID), oraclePriceInfo],
    });
}
//# sourceMappingURL=oracle.js.map